import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import Icons from "../../../../resources/icons/Icons";
import classes from "./QuickDownloadToolBar.module.css";
import Strings from "../../../../resources/Strings";
import { TABLES } from "../../../../enums/Enums";
import {
  getPermanentParkerTemplate,
  getGmtUsersTemplate,
  getHistoryTemplate,
  getDefaultTemplate,
  getBillingHistoryTemplate,
} from "../../../../utils/ExcelUtils";
import { showErrorMessage } from "../../../../utils/MessagesUtils";

const QuickDownloadToolBar = (props) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadExcel = async () => {
    if (isDownloading) return;
    
    try {
      switch (props?.tableId) {
        case TABLES.PARKERS:
          setIsDownloading(true);
          await getPermanentParkerTemplate(props);
          setIsDownloading(false);
          break;
        case TABLES.GMT:
          getGmtUsersTemplate(props);
          break;
        case TABLES.HISTORY:
          getHistoryTemplate(props);
          break;
        case TABLES.BILLING_HISTORY:
          getBillingHistoryTemplate(props);
          break;
        case TABLES.MODAL_TABLE:
          getDefaultTemplate(props);

        default:
          break;
      }
    } catch (err) {
      console.log(err);
      showErrorMessage();
      if (props?.tableId === TABLES.PARKERS) {
        setIsDownloading(false);
      }
    }
  };

  return (
    <div className={classes.quickSearchToolbar}>
      <Button onClick={downloadExcel} disabled={isDownloading}>
        {isDownloading ? (
          <CircularProgress size={20} sx={{ marginRight: '10px', color: 'inherit' }} />
        ) : (
          <img src={Icons.DOWNLOAD}></img>
        )}
        {Strings.DOWNLOAD}
      </Button>
    </div>
  );
};

export default QuickDownloadToolBar;
